<template>
  <search-associates
    class="table-associate-search"
    :is-associate-id="isAssociateId"
    :multiply="multiply"
    :value="associateValue"
    placeholder="Search"
    :data-testid="dataTestid"
    @update:value="updateAssociateFilter"
  />
</template>

<script>
import SearchAssociates from '@/components/search-associates.vue'

export default {
  name: 'TableAssociateSearch',
  components: {
    'search-associates': SearchAssociates
  },
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    filterKey: {
      type: String,
      default: 'associates'
    },
    clearFilterKeys: {
      type: Array,
      default: () => []
    },
    isAssociateId: {
      type: Boolean,
      default: true
    },
    multiply: {
      type: Boolean,
      default: true
    },
    useRouter: {
      type: Boolean,
      default: true
    },
    dataTestid: {
      type: String,
      default: 'table-associate-search'
    }
  },
  computed: {
    associateValue() {
      const value = this.filters?.[this.filterKey]

      if (!this.multiply || Array.isArray(value) || value === undefined || value === null || value === '') {
        return value
      }

      return [value]
    }
  },
  methods: {
    updateAssociateFilter(value) {
      const nextFilters = {
        ...(this.useRouter ? this.$route.query : this.filters)
      }

      if (this.hasFilterValue(value)) {
        nextFilters[this.filterKey] = value
        this.clearFilterKeys.forEach(key => {
          this.clearFilterValue(nextFilters, key)
        })
      } else {
        this.clearFilterValue(nextFilters, this.filterKey)
      }

      if (this.useRouter) {
        this.$router.replace({ query: nextFilters }).catch(() => {})
        return
      }

      this.$emit('update:filters', nextFilters)
    },
    hasFilterValue(value) {
      if (Array.isArray(value)) {
        return value.length > 0
      }

      return value !== undefined && value !== null && value !== ''
    },
    clearFilterValue(filters, key) {
      if (this.useRouter) {
        delete filters[key]
        return
      }

      filters[key] = undefined
    }
  }
}
</script>

<style scoped>
.table-associate-search {
  min-width: 260px;
}
</style>
